import { Injectable } from '@angular/core';

@Injectable()
export class FileHelperService {

  loadJSON(jsonString: string): object {
    const data = JSON.parse(jsonString);

    return data;
  }

  loadTextFileAjaxSync(filePath, mimeType): string {
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.open("GET", filePath, false);
    if (mimeType != null) {
      if (xmlhttp.overrideMimeType) {
        xmlhttp.overrideMimeType(mimeType);
      }
    }
    xmlhttp.send();
    if (xmlhttp.status == 200) {
      return xmlhttp.responseText;
    }
    else {
      return null;
    }
  }
}
